import { render, staticRenderFns } from "./product-category-item.vue?vue&type=template&id=57107dd6&scoped=true&"
import script from "./product-category-item.vue?vue&type=script&lang=js&"
export * from "./product-category-item.vue?vue&type=script&lang=js&"
import style0 from "./product-category-item.vue?vue&type=style&index=0&id=57107dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57107dd6",
  null
  
)

export default component.exports